// extracted by mini-css-extract-plugin
export default {"brandContainer":"Brand_brandContainer__sOL-x","logo":"Brand_logo__3F6u-"};